import { useNavigate } from 'react-router-dom';

export default function Routes({ appRoutes, isAuth, error, loader }) {
    let navigate = useNavigate();

    return (
        <>
            <div className="logo">
                <button onClick={() => navigate("/getting-started", { replace: true })} className="nav-item logo-link"><span className="logo-styled">B</span>it&nbsp;<span className="logo-styled">A</span>egis&nbsp;<span className="logo-styled">W</span>allet</button>
            </div>
            {loader && <p>Loading...</p>}
            {error && <p style={{ color: "red" }}>{error.message}</p>}
            <nav className="nav">
                {
                    appRoutes.map((item, index) => {
                        return (item.isActive === "True" &&
                            <button key={index} className="nav-item" onClick={() => navigate(item.route === "" ? "/" : item.route, { replace: true })}>{item.title}</button>
                        )
                    })
                }
            </nav>
        </>
    )
}
